/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { Component } from 'react';
import { Dropdown } from 'antd';
import { ellipsis as styles } from './header.styles';
import { RouteComponentProps } from 'react-router';
import { DashRoute, DashIcon } from '../../_shared/interfaces/dashroute';
import { connect } from 'react-redux';
import { AppState } from '../../app.state';
import { getNameFromState, isPB } from '../../utils';
import { SvgIcon } from '../../_shared/icon';
import SMStyles from '../side-menu/side-menu.styles';
import { AIcon as Icon, IconFont } from '../../_shared/icon';

interface IProps extends RouteComponentProps {
  sState: AppState;
  routes: DashRoute[];
  changeRoute: (route: DashRoute) => void;
}

export class _Ellipsis extends Component<IProps> {
  renderIcon = (route: DashRoute) => {
    const { icon } = route;

    const props = ({
      theme: 'outlined',
      ...icon,
      css: icon && icon.css ? css(icon.css) : null,
    } as unknown) as DashIcon;

    if (props.lib === 'fontawesome') {
      return (
        <span css={css(SMStyles.faContainer)}>
          <i {...props} className={`far fa-${props.type}`} />
        </span>
      );
    } else if (props.lib === 'iconfont') {
      return <IconFont {...props} />;
    } else if (props.lib === 'SvgIcon') {
      props.css = (css('width: 14px;') as unknown) as string;
      return <SvgIcon {...props} />;
    }
    return <Icon {...props} />;
  };
  // AER-1465: Use Dropdown's `menu.items` API instead of nesting <Menu><Menu.Item/>
  // children. In antd v6 the <Menu> Children API was removed and rendering
  // <Menu.Item> inside a Dropdown popup throws (white screens on every page
  // when the user clicks the triple-dot icon).
  buildMenuItems = () => {
    const { changeRoute, routes } = this.props;
    return routes.map((route, i) => ({
      key: i,
      label: (
        <span css={css(styles.menuItem)}>
          {route.icon && (
            <span css={css(styles.menuIcon)}>{this.renderIcon(route)}</span>
          )}
          {route.title}
        </span>
      ),
      onClick: route.onClick ? route.onClick : () => changeRoute(route),
    }));
  };
  render() {
    const { sState } = this.props;

    const ispb = isPB(sState);
    return (
      <div css={css(styles.container)}>
        {!ispb && <div>{getNameFromState(sState)}</div>}
        <Dropdown
          menu={{ items: this.buildMenuItems() }}
          trigger={['click']}
        >
          <a
            css={css(`${styles.a} cursor: pointer;`)}
            className="ant-dropdown-link"
            onClick={(e) => e.preventDefault()}
          >
            <Icon type="ellipsis" />
          </a>
        </Dropdown>
      </div>
    );
  }
}

export const Ellipsis = connect((state: AppState) => ({ sState: state }))(
  _Ellipsis as any
) as unknown as typeof _Ellipsis;
